import React from 'react';
import Button from '../../common/Button/Button';
import styles from './ContactPreview.module.css';

function ContactPreview() {
  return (
    <section className={styles.contactSection}>
      <div className={`container ${styles.contactContainer}`}>
        <div className={styles.contactInfo}>
          <span className={styles.eyebrow}>Nous Joindre</span>
          <h2 className={styles.title}>Contactez-nous</h2>
          <div className={styles.divider}></div>
          <p className={styles.description}>
            Un projet de construction ? Une question ? N'hésitez pas à nous appeler ou à nous rendre visite.
          </p>

          <div className={styles.infoGrid}>
            <div className={styles.infoBlock}>
              <div className={styles.iconWrapper}>
                <span className={styles.icon}>🕒</span>
              </div>
              <div className={styles.infoContent}>
                <h4>Horaires d'ouverture</h4>
                <p>
                  Lundi - Vendredi : 7h00 - 19h00<br />
                  <span className={styles.closed}>Samedi & Dimanche : Fermé</span>
                </p>
              </div>
            </div>
          </div>

          <div className={styles.ctaWrapper}>
            <Button to="/contact" variant="primary">Envoyer un message</Button>
          </div>
        </div>


        <div className={styles.contactMap}>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2624.991625992268!2d1.6918240156744838!3d48.85837397928751!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e6a4e6b5d0b5d1%3A0x5d5d5d5d5d5d5d5d!2s22%20Rue%20du%20Paradis%2C%2078790%20Arnouville-l%C3%A8s-Mantes!5e0!3m2!1sfr!2sfr!4v1633362633333!5m2!1sfr!2sfr"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            title="Carte de notre localisation"
          ></iframe>
        </div>
      </div>
    </section>
  );
}

export default ContactPreview;
